module.exports = __webpack_public_path__ + "static/media/visor_catastral.ec201427.png";